import React, {useState} from 'react';
import {Modal, Button, Table} from "react-bootstrap";
import {IconButton} from "@mui/material";
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';
import {MachineDetail} from "./MachineDetail";
import {ErrorsDescription} from "../../data/ErrorsDescription";

export const MachineErrorsModal = ({show, onClose, uniqueId, errors}) => {
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [errorLineToLoad, setErrorLineToLoad] = useState([]);

    const handleOpenDetail = (error) => {
        setErrorLineToLoad(error);
        setShowDetailModal(true);
    };

    const handleCloseDetail = () => {
        setShowDetailModal(false);
    };

    return (
        <>
            <MachineDetail
                show={showDetailModal}
                onClose={handleCloseDetail}
                uniqueId={uniqueId}
                errorLine={errorLineToLoad}

            />

            <Modal show={show} onHide={onClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Errors for Machine {uniqueId}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {errors && errors.length > 0 ? (
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>Timestamp</th>
                                    <th>Error Message</th>
                                    <th style={{width: '80px', textAlign: 'center'}}>Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                {errors.map((error, idx) => (
                                    <tr key={idx}>
                                        <td>{error.errorTS || 'N/A'}</td>
                                        <td><ErrorsDescription errorMask1={error.errorMask1}/> </td>
                                        <td style={{textAlign: 'center'}}>
                                            <IconButton
                                                size="small"
                                                onClick={() => handleOpenDetail(error)}
                                                color="primary"
                                                title="View machine details"
                                            >
                                                <PlaylistPlayIcon/>
                                            </IconButton>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <p>No errors found for this machine.</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={onClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};
